import { Link } from "react-router-dom";
import type { NewsArticle } from "@/mocks/news";

type NewsListItemProps = {
  article: NewsArticle;
  index?: number;
};

export default function NewsListItem({ article, index }: NewsListItemProps) {
  return (
    <Link
      to={`/news/${article.id}`}
      className="group grid grid-cols-1 gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors duration-300 hover:border-accent-400 sm:grid-cols-[200px_1fr] md:grid-cols-[240px_1fr]"
    >
      <div className="relative h-[150px] w-full overflow-hidden rounded-md bg-background-200 sm:h-[140px]">
        <img
          src={article.cover}
          alt={`${article.title} 资讯配图`}
          title={`${article.title} · 影视资讯`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-[10px] text-background-50">
          {article.category}
        </span>
      </div>

      <div className="flex min-w-0 flex-col justify-center">
        <div className="flex items-center gap-2 text-[11px] text-foreground-500">
          <i className="ri-calendar-line" />
          <time>{article.date}</time>
          {typeof index === "number" && (
            <span className="ml-auto font-label text-foreground-300">
              NO.{String(index + 1).padStart(2, "0")}
            </span>
          )}
        </div>
        <h3 className="mt-2 clamp-2 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-accent-600 md:text-[17px]">
          {article.title}
        </h3>
        <p className="mt-2 clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
          {article.summary}
        </p>
        <span className="mt-3 flex items-center gap-1 text-xs text-accent-600">
          阅读全文
          <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
}